import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_1164 implements Validator {

    public static id = 'CTRL_1164';
    private message = 'error.ctr_1164';


    public LOG: LogService = new LogService(CTRL_1164);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1164.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChampNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondChampNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                const secondChampCtrl = form.controls[secondChampNameWithStepId];
                if (firstChampCtrl.value == true && secondChampCtrl.value == true) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}